




























import Vue from 'vue';
import { TextDTO } from '@/utils/types/text';
import format from '@/utils/format';
import functions from '@/utils/functions';
import { mapActions } from 'vuex';

const { ifPresent } = functions;

export default Vue.extend({
  name: 'TextCard',
  props: {
    item: Object as () => TextDTO,
  },
  computed: {
    textLink(): string {
      return `texts/${this.item.id}`;
    },
  },
  methods: {
    ...mapActions('text', ['deleteText']),
    callDeleteText() {
      this.deleteText(this.item.id);
    },
  },
  filters: {
    formatDate: ifPresent(format.formatDate),
    formatScore: format.formatReadabilityScore,
  },
});
